interface IObject {
  [a: string]: any;
}

export default (object: IObject, path: string, defaultValue: {} = {}) =>
  path.split(".").reduce((o, p) => (o ? o[p] : defaultValue), object);
